import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import * as _moment from 'moment/moment';
import { Reg } from 'src/app/shared/reg.model';
import { RegService } from 'src/app/shared/Reg.Service';
import { Resp } from 'src/app/shared/resp.model';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { AppInsightsService } from 'src/app/shared/AppInsights.Service';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss'],
})
export class StepOneComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() emitter: EventEmitter<string> = new EventEmitter();
  public type: string;
  public showPlaceholder: boolean;
  public show = false;
  @Input() userid = '';
  @Input() govid = '';
  @Input() lastname = '';
  @Input() pnumber = '';
  public pasteData = '';
  public step1 = false;
  public step2 = false;
  public isLoading = false;
  error: boolean;
  message: any;
  public dob: Date;
  public resp: Resp;
  public uuid: string;
  public validate = true;
  public minDate = new Date(1900, 0, 1);
  public maxDate = new Date(2020, 0, 1);
  public isMonth = false;
  public isDay = false;
  public isYear = false;
  public formFieldError: any = {
    lastname: false,
    dob: false,
    govid: false,
    validGovid: false
  };
  constructor(public regService: RegService, private appInsightsService: AppInsightsService) {
  }

  mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // mm/dd/yyyy
  ssnmask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // 000-00-0000
  maskedInputController;

  @ViewChild('last') last: ElementRef;
  @ViewChild('input') input: ElementRef;
  @ViewChild('ssn') ssnInput: ElementRef;

  ngOnInit() {
  	window.scroll(0, 0);
    this.type = 'password'; // display as '*'
    this.showPlaceholder = true;
    this.generateSession();
    this.appInsightsService.logEvent("Employee Registration UI Step One");
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maskedInputController = textMask.maskInput({
        inputElement: this.input.nativeElement,
        mask: this.mask,
        guide: false
      });
      this.maskedInputController = textMask.maskInput({
        inputElement: this.ssnInput.nativeElement,
        mask: this.ssnmask,
        guide: false
      });
    });
  }

  ngOnDestroy() {
    this.maskedInputController.destroy();
  }

  openDate(datePicker){
    datePicker.open();
    this.dob= null;
    (document.getElementById("dpicker") as HTMLInputElement).value = '';
  }
  
  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.validateForm('dob');
  }

  focusOnInput() {
    let setError = false;
    if (!!this.formFieldError.lastname) {
      setError = true;
      setTimeout(() => this.last.nativeElement.focus(), 0);
      setTimeout(() => this.last.nativeElement.select(), 0);
      window.scrollTo(0,this.last.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formFieldError.dob) {
      setError = true;
      setTimeout(() => this.input.nativeElement.focus(), 0);
      setTimeout(() => this.input.nativeElement.select(), 0);
      window.scrollTo(0,this.input.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formFieldError.govid || !!this.formFieldError.validGovid) {
      setError = true;
      setTimeout(() => this.ssnInput.nativeElement.focus(), 0);
      setTimeout(() => this.ssnInput.nativeElement.select(), 0);
      window.scrollTo(0,this.ssnInput.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }
    return setError;
  }

  isErrorPresent() {
    if (!this.formFieldError.lastname && !this.formFieldError.dob
      && !this.formFieldError.govid && !this.formFieldError.validGovid) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['lastname', 'dob', 'govid'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      if (fields[j] === 'dob') {
    		let dobVal =(document.getElementById("dpicker") as HTMLInputElement).value;
    		isErrPresent = !this.isDatePattern(dobVal) ? true : false;
		      if (isErrPresent) {
		      	this.formFieldError.dob = true;
		        break;
		      }
    	} else {
    		isErrPresent = this.validateForm(fields[j]);
		      if (isErrPresent) {
		        break;
		      }
    	}  
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }

  validateForm(model) {
    let error = false;
    this.validate = true;

    if (model === 'lastname') {
      if (!this.lastname) {
        error = true;
        this.formFieldError.lastname = true;
      } else {
        this.formFieldError.lastname = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'dob') {
      const isOpen = document.getElementsByClassName('mat-datepicker-popup').length === 0 ? false : true;
      if (isOpen) { return; }
      let textDate = (document.getElementById("dpicker") as HTMLInputElement).value;
      if (textDate === "") {
      	this.isMonth = this.isDay = this.isYear = false;
      	this.formFieldError.dob = false;
        this.ifAtleastOneFieldValidated(model);
      } else if (!this.isValidDate(textDate)) {
        this.formFieldError.dob = true;
        error = true;
      } else {
        this.formFieldError.dob = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'govid') {
      if (!this.govid) {
        this.formFieldError.govid = true;
        this.formFieldError.validGovid = false;
        error = true;
      } else if (this.govid !== '' && this.govid.replace(/[- ()]/g, '').length !== 9) {
        this.formFieldError.validGovid = true;
        this.formFieldError.govid = false;
      } else {
        this.formFieldError.govid = false;
        this.formFieldError.validGovid = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    console.log(this.formFieldError, error);
    if (!!this.lastname && !!this.dob && !!this.govid && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }

isDatePattern(dateString) {
	// First check for the pattern
	if(/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
		return true;
	} 	    
  }
  
  
  //Validates that the input string is a valid date formatted as "mm/dd/yyyy"
  isValidDate(dateString) {
	    // Parse the date parts to integers
	    let isValid = false;
	    let parts = dateString.split("/");
	    let month = parseInt(parts[0], 10);
	    let day = parseInt(parts[1], 10);	    
	    let year = parseInt(parts[2], 10);
					  	    
		// Check the ranges of month
	    if (!isNaN(month)) {
	    	if(month > 12) {
	    		this.isMonth = false;
	    	} else {
	    		this.isMonth = true;
		    }   	
	    }
	    
	    // Check the ranges of day
	    if (!isNaN(day)) {
	    	let monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
	
		    // Adjust for leap years
		    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
		    	monthLength[1] = 29;
		    }		        
			
		    // Check the range of the day
		    if(day <= monthLength[month - 1]) {		    	 
		    	this.isDay = true;
		    } else {
		    	this.isDay = false;
		    }       	
	    }
	    
	    // Check the ranges of year
	    if (!isNaN(year)) {
	    	if (year.toString().length === 1) {
	    		if(parseInt(year.toString().charAt(0)) === 1 || parseInt(year.toString().charAt(0)) === 2) {
	    			this.isYear = true;
		    	} else {
			    	this.isYear = false;
			    }  
	    	}
	    	if (year.toString().length === 2) {
	    		if((parseInt(year.toString().charAt(0)) === 1 || parseInt(year.toString().charAt(0)) === 2) && 
	    			(parseInt(year.toString().charAt(1)) === 9 || parseInt(year.toString().charAt(1)) === 0)) {
	    			this.isYear = true;
		    	} else {
			    	this.isYear = false;
			    }  
	    	}
	    	if (year.toString().length === 3) {
	    		if((parseInt(year.toString().charAt(0)) === 1 || parseInt(year.toString().charAt(0)) === 2) && 
	    			(parseInt(year.toString().charAt(1)) === 9 || parseInt(year.toString().charAt(1)) === 0) &&
	    			(parseInt(year.toString().charAt(2)) >= 0 || parseInt(year.toString().charAt(2)) <= 9)) {
	    			this.isYear = true;
		    	} else {
			    	this.isYear = false;
			    }  
	    	}
	    	if (year.toString().length === 4) {
	    		if(year < 1900 || year > new Date().getFullYear()) {
	    			this.isYear = false;
		    	} else {
			    	this.isYear = true;
			    } 
	    	}    	     	
	    }
	    
	    if ((/^\d{1,2}$/.test(dateString) || /^\d{1,2}\/$/.test(dateString)) && this.isMonth) {
	    	isValid = true;
	    }
	    
	    if ((/^\d{1,2}\/\d{1,2}$/.test(dateString) || /^\d{1,2}\/\d{1,2}\/$/.test(dateString)) && this.isMonth && this.isDay) {
	    	isValid = true;
	    }
	    
	    if (/^\d{1,2}\/\d{1,2}\/\d{1,4}$/.test(dateString) && this.isMonth && this.isDay && this.isYear) {
	    	isValid = true;
	    }
	    
	    if (this.formFieldError.dob && !this.isDatePattern(dateString)){
  			return false;
  		} else {
  			return isValid;
  		}
	    	    	    
  };

  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }

  togglePlaceholder(event: FocusEvent, modelName) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  toggleForm(event: FocusEvent, modelName) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
    this.validateForm(modelName);
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }

  continue() {
    console.log('waiting for response...');

    if (!this.validateAllFields()) {
      setTimeout(() => {
        this.error = false;
        this.isLoading = true;
        this.message = '';
        this.validate = true;
      });
      const reg = new Reg();
      if (this.dob) {
        reg.axaDOB = _moment(this.dob).format('MM/DD/YYYY');
      }
      reg.axassn = this.govid.replace(/[- ()]/g, '');
      reg.lastName = this.lastname;
      reg.sessionId = this.uuid;

      if (this.pasteData === this.govid) {
        reg.ssnPasteEvent = 'Yes';
      } else {
        reg.ssnPasteEvent = 'No';
      }
      const bodyString = JSON.stringify(reg);
      this.regService.regStepOne(bodyString).subscribe(res => {
        this.resp = res;
        if (this.resp && this.resp !== undefined && Object.keys(this.resp).length > 0) {
          setTimeout(() => {
            this.isLoading = false;
          });
          if (this.resp.status_code !== '200') {
          	window.scroll(0, 0);
            this.error = true;
            this.validate = false;
            if (this.resp.message) {
              this.message = this.resp.message;
            } else {
              this.message = 'Session has expired please close browser and try again';
            }
            setTimeout(() => {
		      this.maskedInputController = textMask.maskInput({
		        inputElement: this.input.nativeElement,
		        mask: this.mask,
		        guide: false
		      });
		      this.maskedInputController = textMask.maskInput({
		        inputElement: this.ssnInput.nativeElement,
		        mask: this.ssnmask,
		        guide: false
		      });
		    });
          } else {
            console.log('url ' + this.resp.url);
            window.location.href = window.location.origin + this.resp.url;
          }
        }
      });
    } else {
      this.focusOnInput();
    }
  }
  goBack() {
    window.history.go(-2);
  }
  generateSession() {
    let dt = new Date().getTime();
    this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
      function(c) {
        const r = (dt + Math.random() * 16) % 16 | 0; dt = Math.floor(dt / 16); return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    console.log('session: ' + this.uuid);
  }
}
